import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';

import { List } from 'antd';

function TourListingList({ virtualTour, retsId, dashboardId }) {
  const [listings, setListings] = useState([]);
  const isExternal = retsId || dashboardId;
  useEffect(() => {
    const fetchListings = async () => {
      const { data } = await axios.get(
        isExternal
          ? `/external/virtual_tour/${virtualTour.id}/listings`
          : `/virtual_tour/${virtualTour.id}/listings`,
        {
          params: { retsId, dashboardId },
        },
      );
      setListings(data);
    };

    if (virtualTour.id) {
      fetchListings();
    }
  }, [virtualTour]);

  const removeListing = async listingId => {
    const { value } = await Swal.fire({
      title: 'Remove From Tour',
      text: 'Are you sure you want to remove this property from the tour?',
      type: 'error',
      cancelButtonColor: '#3085d6',
      confirmButtonColor: '#d33',
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonText: 'Yes, Remove',
      cancelButtonText: 'Cancel',
    });
    if (value) {
      await axios.post(
        isExternal
          ? `/external/virtual_tour/${virtualTour.id}/property_to_tour`
          : `/virtual_tour/${virtualTour.id}/property_to_tour`,
        {},
        {
          params: {
            listingId,
            retsId,
            dashboardId,
          },
        },
      );
      const newListings = [...listings];
      listings.forEach((listing, i) => {
        if (listing.id === listingId) {
          newListings.splice(i, 1);
          setListings(newListings);
        }
      });
    }
  };

  return (
    <List
      itemLayout="horizontal"
      dataSource={listings}
      renderItem={listing => (
        <List.Item
          actions={[
            <a
              key="list-remove"
              onClick={() => removeListing(listing.id)}
              style={{ color: 'red' }}
              data-cy={`remove-listing-${listing.id}`}
            >
              <i className="fa fa-times"></i> Remove From Tour
            </a>,
          ]}
        >
          <List.Item.Meta
            title={
              <a
                style={{ color: 'dodgerblue' }}
                data-cy={`listing-address-${listing.id}`}
              >
                {listing.line1} {listing.line2}
              </a>
            }
          />
        </List.Item>
      )}
    />
  );
}

export default TourListingList;
